export const RELATIVE_TIMES = {
  pastSuffix: "قبل", // in arabic language this is a prefix
  now: "الان",
  s: {
    plural: "ثانية",
  },
  mm: {
    singular: "دقيقة",
    double: "دقيقتين",
    plural: "دقائق",
  },
  hh: {
    singular: "ساعة",
    double: "ساعتين",
    plural: "ساعات",
  },
  dd: {
    singular: "يوم",
    double: "يومين",
    plural: "أيام",
  },
  ww: {
    singular: "اسبوع",
    double: "اسبوعين",
    plural: "اسابيع",
  },
  MM: {
    singular: "شهر",
    double: "شهرين",
    plural: "أشهر",
  },
  yy: {
    singular: "سنة",
    double: "سنتين",
    plural: "سنوات",
  },
};

export const SPEC_ICONS = {
  beds: "Bed",
  livings: "Couch",
  wc: "Bath",
  area: undefined,
  type: "Tag",
  street_width: "Road",
};

export const MINI_CAT_ICONS_MAP = {
  // Apartment or Big Flat
  1: ["area", "beds", "livings", "wc"],
  4: ["area", "beds", "livings", "wc"],
  6: ["area", "beds", "livings", "wc"],
  // Villa, Small House, Lounge
  3: ["area", "beds", "livings", "wc"],
  5: ["area", "beds", "livings", "wc"],
  9: ["area", "beds", "livings", "wc"],
  10: ["area", "beds", "livings", "wc"],
  11: ["area", "beds", "livings", "wc"],
  13: ["area", "beds", "livings", "wc"],
  // Store,Farm,Office, Warehouse
  8: ["area"],
  20: ["area"],
  12: ["area"],
  14: ["area"],
  17: ["area"],
  // Building
  7: ["area", "apts", "stores", "type"],
  16: ["area", "apts", "stores", "type"],
  // Land
  2: ["area", "street_width", "type"],
  15: ["area", "street_width", "type"],
};

// TODO: Think of handling this in the i18n layer
export const SPEC_VALUES = {
  type: {
    1: "سكني",
    2: "تجاري",
    3: "سكني/تجاري",
  },
};

export const URL_LEVELS = {
  CATEGORY: "CATEGORY",
  CITY: "CITY",
  DIRECTION: "DIRECTION",
  DISTRICT: "DISTRICT",
  LISTING: "LISTING",
};

export const TESTING_TARGET = "test";

export const TYPES_KEYFIELD_MAP = {
  CityType: "uri",
  DirectionType: "uri",
  DistrictType: "path",
};

export const PAGE_TITLES = {
  downloadPage: "تنزيل برنامج عقار | تطبيق عقار",
  forgotPasswordPage: "استرجاع كلمة العبور | تطبيق عقار",
  loginPage: "تسجيل الدخول | تطبيق عقار",
  signUpPage: "انشاء حساب | تطبيق عقار",
  partnersPage: "شركاء النجاح | تطبيق عقار",
  servicesPage: "الخدمات | تطبيق عقار",
  termsPage: "اتفاقية الاستخدام | تطبيق عقار",
};

export const STATS_CATEGORIES_IDS = [1, 2, 3];

export const STATS_CITIES_IDS = {
  21: { label: "الرياض", uri: "الرياض" },
  66: { label: "جدة", uri: "جدة" },
  18: { label: "الدمام", uri: "الدمام" },
  94: { label: "مكة المكرمة", uri: "مكة-المكرمة" },
  41: { label: "المدينة المنورة", uri: "المدينة-المنورة" },
  12: { label: "الخبر", uri: "الخبر" },
};

export const APP_ID = 879992882;
export const DEFAULT_STATS_CITY_ID = 21;

export const VALID_PAYMENT_SERVICES = [
  "packages",
  "fees",
  "ejar-fees",
  "ejar-ecrs-fees",
  "purchase-user",
  "corporate-package",
  "boost-listing",
];

export const AUTH_SERVICES = [
  "packages",
  "purchase-user",
  "corporate-package",
  "boost-listing",
];

export const VIDEO_ORIENTATION = "1280x720";
